import { queryClient } from '@/lib/queryClient'
import { flattenPages } from '@/utils/flattenPages'

import { QueryKeys } from '@/enums'

import { getReactionActivityId } from '../../getReactionActivityId'

export const getTimelineFeedActivityIds = () => {
  const timelineFeedQueryData = queryClient.getQueryData([
    QueryKeys.TimelineFeed,
  ])
  const timelineFeedActivityIds = []

  const timelineFeed = flattenPages(timelineFeedQueryData, 'data')

  timelineFeed.forEach((activity) => {
    const reactionActivityId = getReactionActivityId(activity)

    timelineFeedActivityIds.push(reactionActivityId)
  })

  return timelineFeedActivityIds
}
